import {
  CLEAR_WHAT_INCLUDES_DATA,
  FETCH_WHAT_INCLUDES_DATA_ERROR,
  FETCH_WHAT_INCLUDES_DATA_INIT,
  FETCH_WHAT_INCLUDES_DATA_SUCCESS,
} from 'action-creators/payway/whatIncludes/constants';

const initialState = {
  inProgress: true,
  success: null,
  error: null,
  data: null,
  offer_type: null,
};

const whatIncludesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WHAT_INCLUDES_DATA_INIT:
      return { ...initialState, inProgress: true };
    case FETCH_WHAT_INCLUDES_DATA_SUCCESS:
      return { ...state, inProgress: false, success: true, data: action?.data, offer_type: action?.offer_type };
    case FETCH_WHAT_INCLUDES_DATA_ERROR:
      return { ...state, inProgress: false, data: null, error: action.error, offer_type: null };
    case CLEAR_WHAT_INCLUDES_DATA:
      return { ...initialState };
    default:
      return state;
  }
};

export default whatIncludesReducer;
